export default "__VITE_ASSET__3LpvRuSl__"